<template>
  <section class="ecir-presale__section">
    <div class="ecir-presale__content">
      <div class="ecir-presale__text">
        <div class="ecir-presale__text-title-enquiry">PRESALE SAVINGS FOR NEW SUBSCRIBERS</div>
        <div class="ecir-presale__text-title">Buy Now and Save $200!</div>
        <div class="ecir-presale__details">
          Presale is available now for NEW SUBSCRIBERS! Purchase the Certified Incident Responder
          (eCIR) exam voucher during presale and receive three months of INE Premium subscription to
          help you prep! Don't wait - save $200 now and be one of the first eligible to take the
          eCIR exam when it becomes available this summer!
        </div>
        <div class="ecir-presale__cta">
          <button class="btn btn--primary btn--responsive btn--full-mobile" @click="claimDealCTA">
            Save Now
          </button>
        </div>
      </div>
      <img
        :src="require(`@/assets/icons/certs/ecir_badge.png`)"
        alt="eCIR Premium Dynamic Exam"
        class="ecir-presale__badge"
      />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { updateCart } from '@/helpers/mixins'
import CONSTANTS from '@/constants'

export default {
  name: 'EcirPreSaleHeroSection',
  mixins: [updateCart],
  methods: {
    getPlan(merchantId) {
      return this.availablePlans.find(plan => plan.merchant_id === merchantId)
    },
    claimDealCTA() {
      const currentPlan = this.getPlan(CONSTANTS.PLANS.ECIR_PREMIUM)
      this.updateSelectedPlan(currentPlan)
      this.$router.push({
        name: this.userProfile.email ? 'payment' : 'account',
      })
    },
  },
  computed: {
    ...mapState({
      availablePlans: state => state.products.availablePlans,
      userProfile: state => state.auth.userProfile,
    }),
  },
}
</script>

<style lang="scss">
.ecir-presale {
  &__section {
    padding: 30px 20px;
    @include mobile {
      padding: 30px 20px;
    }
    @include tablet {
      padding: 20px 33px;
    }
    @include desktop {
      padding: 90px 20px;
    }
  }
  &__content {
    display: flex;
    flex-flow: column-reverse;
    align-items: center;
    gap: 40px;
    @include mobile {
      flex-flow: row;
      gap: 40px;
      max-width: 1080px;
      margin: auto;
    }
    @include tablet {
      max-width: 1120px;
    }
    @include desktop {
      gap: 68px;
      align-items: center;
    }
  }
  &__badge {
    width: 50%;
    max-width: 152px;
    @include mobile {
      width: 211px;
      max-width: 100%;
    }
    @include desktop {
      width: 423px;
    }
  }
  &__text {
    @include font-medium;
    color: var(--white);
    &-title {
      margin-top: 10px;

      color: var(--white);
      font-feature-settings: 'clig' off, 'liga' off;

      @include font-book;
      font-size: 2rem;
      font-style: normal;
      font-weight: 700;
      line-height: 2.375rem; /* 118.75% */

      @include mobile {
        font-size: 2.5rem;
        line-height: 3.25rem;
      }
      @include desktop {
        font-size: 3.375rem;
        line-height: 3.75rem;
      }
      &-enquiry {
        color: var(--light-purple);
        font-feature-settings: 'clig' off, 'liga' off;
        text-shadow: 0px 0px 24px #000;

        @include font-book;
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 450;
        line-height: 1.25rem; /* 142.857% */

        @include mobile {
          font-size: 1rem;
          line-height: 1.4375rem;
        }
        @include desktop {
          font-size: 0.9375rem;
          line-height: 0.875rem;
        }
      }
    }
  }
  &__details {
    margin-top: 10px;

    color: var(--white);
    font-feature-settings: 'clig' off, 'liga' off;
    @include font-book;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.25rem; /* 142.857% */

    @include desktop {
      font-size: 1.125rem;
      line-height: 1.5rem;
    }
    &--link {
      color: var(--purple-pale);
      font-size: rem(18px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(24px);
      cursor: pointer;
    }
  }
  &__cta {
    margin-top: 10px;
    @include mobile {
      margin-top: 20px;
    }
    @include desktop {
      margin-top: 40px;
    }
    &--hide {
      display: none !important;
    }
  }
}
</style>
